module.exports = __webpack_public_path__ + "img/1.5100fb7d.jpg";